import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import { SenriClient } from "../setup/models/senri-client.model";
import { Distributor } from "../setup/models/distributor.model";

@Injectable()
export class DashboardService {
    constructor(
        private httpClient: HttpClient,
        private authService: AuthenticationService,
    ) {}

    // MAIN RECORDS
    getSenriClients() {
        return this.httpClient.get<SenriClient[]>(
            environment.apiBaseUrl.concat("SenriClient"),
        );
    }

    getDistributors(senriClientId: number) {
        return this.httpClient.get<Distributor[]>(
            environment.apiBaseUrl.concat("Distributor"),
            {
                params: {
                    senriClientId: senriClientId.toString(),
                    include: "Active",
                },
            },
        );
    }
}
